/** Created by azhou on 2019/3/11.*/
<template>
  <ul class="list-item">
    <li class="w-25 list-item-col">
        <span v-if="!showSortInput">{{ Itemize.sort}}</span>
        <el-input class="w-50" v-model="Itemize.sort" v-else type="number"></el-input>
    </li>
    <li class="w-50 list-item-col">{{Itemize.title}}</li>
    <li class="w-50 list-item-col">
      <div v-if="Itemize.pic.length==0" class="pic-item" @click="clickUpload(Itemize)">
        <div class="pic-item-text">待上传图片</div>
        <div class="pic-item-icon">
          <i class="iconfont icon-tianjiatupian"></i>
        </div>
      </div>
      <upload-image @fileChange="(imgs)=>RoomObj.pic = imgs" :existImgs="Itemize.pic"  :indexLength="2" :pattern="true" v-else/>  
    </li>
    <li class="w-50 list-item-col layout" :class="{'center':Itemize.layout.length<3}">
      <div v-for="value in Itemize.layout" :key="value.type"  class="layout-item">
        <!-- <img :src="'/images/bj/icon_'+value.type+'.png'" class="list-item-img"/> -->
        <div>{{value.type | formatVar('FacilitiesFacility')}}</div>
        <!-- <div><span class="text-info list-item-num">{{value.num}}</span>人</div> -->
      </div>
    </li>
    <li class="w-25 list-item-col"><span class="text-info">{{Itemize.high}}</span>m</li>
    <li class="w-25 list-item-col"><span class="text-info">{{Itemize.area}}</span>m²</li>
    <li class="w-50 list-item-col-end">
      <span class="text-link" @click="clickUpload(Itemize)">修改图片</span>
      <span class="ml-2 text-link" @click="$emit('editItem')">编辑信息</span>
         <span class="text-link ml-2" @click="$emit('clone')">克隆</span>
      <span class="ml-2 text-link" @click="$emit('deleteItem')">删除</span>
    </li>
  </ul>
</template>

<script>

  export default {
    name: 'Itemize',
    props: {
      Itemize:{},
      showSortInput:Boolean
    },
    methods: {
      clickUpload(item){
        this.$emit('uploadPic',item)
      }
    }
  }
</script>
<style  scoped>
  .layout{
    display: flex;
    flex-wrap: wrap;
    justify-content: left;
  }
  .list-item-img{
    width: 50%;
    width: 16px;
    height: 16px;
    margin-top:1px;
    margin-right: 6px;
    display: block;
    margin: 0 auto;
  }

  .layout-item{
    width: 33%;
    font-size: 12px;
  }

  .layout-item p{
    display: inline-block;
    line-height: 20px;
  }
  .list-item-num{
    display: inline-block;
  }
  .center{
    justify-content: center;
  }
    .pic-item{
    width: 70px;
    height: 70px;
    padding-left: 20px;
  }
  .pic-item-text{
    font-size: 10px;

  }
  .pic-item-icon{
    width: 50px;
    height: 50px;
    border: 1px #eee dashed ;
    margin: 0 auto;
    border-radius: 4px;
    margin-top:4px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
  }
  .icon-tianjiatupian{
    color: #999;
  }
</style>
